import { render, staticRenderFns } from "./ProductVariantsInput.vue?vue&type=template&id=5eba3936&"
import script from "./ProductVariantsInput.vue?vue&type=script&lang=ts&"
export * from "./ProductVariantsInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports